import React from 'react';
import { SectionHeading } from './SectionHeading';
import { todayList, tomorrowList } from '../data/content';
export function TransformSection() {
  return <section className="bg-cream px-4 py-6 sm:px-6" data-id="element-239" data-mp="2z7q6j24atmwk">
      <SectionHeading size="lg" data-id="element-240" data-mp="2lf9z7p4d72pu">
        From “What do we do today?” to a complete activity system
      </SectionHeading>

      <p className="mt-2.5 text-center text-[13px] font-semibold text-graphite sm:text-sm" data-id="element-241" data-mp="2qdtjll3b86g3">
        Think about the difference.
      </p>

      <div className="mx-auto mt-3 grid max-w-2xl gap-2 sm:grid-cols-2" data-id="element-242" data-mp="3i4hj6spc53rn">
        <div className="rounded-md border border-graphite/20 bg-white p-3" data-id="element-243" data-mp="3i2djkmygyqx6">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-graphite/60" data-id="element-244" data-mp="343x4o8qgdu3y">
            Today:
          </p>
          <ul className="mt-1.5 space-y-1" data-id="element-245" data-mp="395mfpodoe7s1">
            {todayList.map(item => <li key={item} className="text-[12px] font-medium leading-snug text-graphite/70 line-through" data-id="element-246" data-mp="1so8hphd78v35">
                {item}
              </li>)}
          </ul>
        </div>

        <div className="rounded-md border-2 border-teal bg-white p-3" data-id="element-247" data-mp="19mw0q8zin8we">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-teal" data-id="element-248" data-mp="19oyxdbv6c0a3">
            Tomorrow:
          </p>
          <ul className="mt-1.5 space-y-1" data-id="element-249" data-mp="1imremlkghi04">
            {tomorrowList.map(item => <li key={item} className="text-[12px] font-semibold leading-snug text-navy" data-id="element-250" data-mp="1wmtszxtk1tam">
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <p className="mx-auto mt-3 max-w-2xl text-center text-[13px] font-medium leading-snug text-graphite sm:text-sm" data-id="element-251" data-mp="26btv3q3ct4t1">
        <strong className="font-extrabold text-navy" data-id="element-252" data-mp="21ebt6jnr7puj">
          One organized professional resource.
        </strong>{' '}
        That’s what SENIOR ACTIVITY READY™ is designed to give you.
      </p>
    </section>;
}